module.exports = __webpack_public_path__ + "img/home-rbn-8.9cbd2b64.png";